module.exports = "<button class='btn btn-primary'(click)=\"goToOrderView(rowData)\">Modifica</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/orders-in-progress/button-order-view/button-order-view.component.html
// module id = ./src/app/orders-in-progress/button-order-view/button-order-view.component.html
// module chunks = main